import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/mini';
import { StatementsPage } from '../components/pages/StatementsPage/StatementsPage';

const searchSchema = z.object({
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/statements')({
  component: StatementsPage,
  validateSearch: searchSchema.parse,
});
